import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const TermsOwners = () => {
  return (
    <div className="min-h-screen">
      <div 
        className="relative bg-cover bg-center py-20"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://customer-assets.emergentagent.com/job_elementor-site-1/artifacts/ff4gwxo8_ChatGPT%20Image%2031.%203.%202026%2023_45_22.png')`,
        }}
      >
        <Header />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 pt-32 sm:pt-44 lg:pt-52 pb-4 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">Obchodní podmínky pro majitele pozemků</h1>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <Card className="shadow-xl">
          <CardHeader>
            <CardTitle className="text-3xl">Podmínky pro nabídku pozemků na WildCamping.cz</CardTitle>
            <p className="text-gray-600 mt-2">Platnost od: 1. ledna 2026</p>
          </CardHeader>
          <CardContent className="p-6 space-y-6">
            <section>
              <h2 className="text-2xl font-bold mb-3">1. Základní ustanovení</h2>
              <p className="text-gray-700 leading-relaxed">
                Těmito obchodními podmínkami se řídí vztah mezi provozovatelem platformy WildCamping.cz 
                a majiteli pozemků, kteří nabízejí své pozemky k dočasnému užívání pro účely kempování.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">2. Provize platformy</h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                Platforma WildCamping.cz si účtuje provizi <strong>15% z celkové ceny rezervace</strong>. 
                Zbývajících <strong>85% je vyplaceno majiteli pozemku</strong>.
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Provize pokrývá provoz platformy, marketing a zákaznickou podporu</li>
                <li>Výplata je realizována do 7 pracovních dnů po ukončení rezervace</li>
                <li>Platba je prováděna přes Stripe Connect na váš bankovní účet</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">3. Povinnosti majitele</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Poskytovat pravdivé a aktuální informace o pozemku</li>
                <li>Dodržovat schválené ceny a pravidla stanovená v nabídce</li>
                <li>Zajistit bezpečnost a přístupnost pozemku</li>
                <li>Informovat hosty o případných změnách nebo omezeních</li>
                <li>Dodržovat české právní předpisy týkající se ubytování a kempování</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">4. Co můžete nabízet</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Soukromé pozemky vhodné pro stanování, karavany nebo offroad vozidla</li>
                <li>Místa s minimálním základním vybavením (ohniště, přístup k vodě apod.)</li>
                <li>Pozemky v přírodě s možností krátkodobého pobytu (1-7 nocí)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">5. Co NELZE nabízet</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Pozemky bez souhlasu vlastníka</li>
                <li>Lokace v chráněných oblastech bez povolení</li>
                <li>Nebezpečné nebo znečištěné lokality</li>
                <li>Místa bez minimálního sanitárního zázemí nebo přístupu k vodě v okolí</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">6. Hodnocení a reputace</h2>
              <p className="text-gray-700 leading-relaxed">
                Po každé rezervaci mají hosté možnost ohodnotit váš pozemek. Zároveň můžete vy ohodnotit 
                hosty. Hodnocení pomáhá budovat důvěru v komunitě a zlepšovat kvalitu služeb.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">7. Storno podmínky</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                <li>Majitel může zrušit rezervaci nejpozději 48 hodin před příjezdem hosta</li>
                <li>Opakované rušení může vést k pozastavení účtu</li>
                <li>V případě vyšší moci (počasí, havárie) kontaktujte podporu</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">8. Odpovědnost</h2>
              <p className="text-gray-700 leading-relaxed">
                Majitel pozemku odpovídá za bezpečnost a stav pozemku. Platforma WildCamping.cz 
                nezodpovídá za škody vzniklé na pozemku nebo zdraví hostů.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">9. Ukončení spolupráce</h2>
              <p className="text-gray-700 leading-relaxed">
                Platforma si vyhrazuje právo ukončit spolupráci s majitelem při porušení těchto podmínek 
                nebo při opakovaných stížnostech hostů.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-3">10. Kontakt</h2>
              <p className="text-gray-700 leading-relaxed">
                Pro dotazy kontaktujte náš tým na <a href="mailto:info@wildcamping.cz" className="text-orange-600 hover:underline">info@wildcamping.cz</a>
              </p>
            </section>

            <div className="mt-8 pt-6 border-t">
              <p className="text-sm text-gray-500">
                Přečetl/a jsem si a souhlasím s těmito obchodními podmínkami.
              </p>
              <p className="text-sm text-gray-500 mt-2">
                Kliknutím na "Přidat místo" souhlasíte s těmito podmínkami.
              </p>
              <Link to="/add-location" className="text-orange-600 hover:text-orange-700 font-semibold mt-4 inline-block">
                → Přidat své místo
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>

      <Footer />
    </div>
  );
};

export default TermsOwners;